var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{staticClass:"button",attrs:{"data-ico":"","aria-label":_vm.localizer.get('App.Common.Search_Placeholder')},on:{"click":function($event){return _vm.openSearchBox()}}},[_c('span',{staticClass:"icon fastic-search",attrs:{"role":"none"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }